import { Component, OnInit } from '@angular/core'

@Component({
  standalone: false,
  selector: 'app-map-loading',
  template: `<div>{{ 'Loading' | translate }}</div>`,
  styleUrls: ['./map-loading.component.scss'],
})
export class MapLoadingComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
